import React, { useEffect, useMemo, useState } from 'react';
import SignupContentWrapper from '../components/SignupContentWrapper';
import SimpleTextFieldComponent from '../components/SimpleTextFieldComponent';
import { useTranslation } from 'react-i18next';
import { emailRegExp } from '../utils/validationRegExp';
import { PATH } from '../../../routes';
import { pushEvent } from '../../../utils/clevertapUtils';
import {
    CLICK_USER_EMAIL_PAGE_OK_BTN,
    VIEW_USER_EMAIL_PAGE,
} from '../../../utils/clevertapEvents';
import { useInvokeApi } from '../utils/useInvokeApi';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { signSetAction } from '../../../store/signup/actions';
import { useNavigate } from 'react-router-dom';
import { userEmailApiText } from '../../../store/signup/types';
import { useRouteConfig } from '../utils/useRouteConfig';
import { AppState } from '../../../store';

const STEP_INFO = 2;
const validation = (value: string | undefined): boolean =>
    !!value && emailRegExp.test(value);

const UserEmail: React.FC = () => {
    const { t } = useTranslation();
    const uuid = useSelector((state: AppState) => state.Signup.uuid);
    const dispatch = useAppDispatch();
    const push = useNavigate();
    const [email, setEmail] = useState<string>('');
    const [requestState, makeRequest] = useInvokeApi<{}>();
    const { next, previous } = useRouteConfig(PATH.SIGNUP.STEPS.FIVE);
    const copy = useMemo(
        () => ({
            heading: t('signup.userEmail.heading'),
            subHeading: t('signup.userEmail.subHeading'),
            validationErrorText: t(
                'signup.userEmail.errors.validationErrorText',
            ),
            nullErrorText: t('signup.userEmail.errors.nullErrorText'),
            placeholderText: t('signup.userEmail.placeholderText'),
        }),
        [t],
    );
    const onSubmit = (value?: string) => {
        if (value) {
            pushEvent(CLICK_USER_EMAIL_PAGE_OK_BTN);
            setEmail(value);
            makeRequest('POST', '/signup/validate', {
                uuid,
                [userEmailApiText]: value,
            });
        }
    };
    useEffect(() => {
        if (requestState.type === 'REQUEST_SUCCESS') {
            dispatch(
                signSetAction({
                    userEmail: email,
                }),
            );
            next && push(next);
        }
        // eslint-disable-next-line
    }, [requestState]);
    useEffect(() => {
        pushEvent(VIEW_USER_EMAIL_PAGE);
    }, []);
    return (
        <SignupContentWrapper
            heading={copy.heading}
            subHeading={copy.subHeading}
            stepInfo={STEP_INFO}
            showCloseButton={true}
            backUrl={previous}
        >
            <SimpleTextFieldComponent
                type="text"
                reduxKey="userEmail"
                nextLink={next || ''}
                errorText={copy.validationErrorText}
                nullErrorText={copy.nullErrorText}
                placeholderText={copy.placeholderText}
                requestState={requestState}
                onSubmit={onSubmit}
                validation={validation}
                maxLength={255}
            />
        </SignupContentWrapper>
    );
};

export default UserEmail;
